import { PageHero } from '@/components/PageHero'
import { company } from '@/config/company'
import { aboutParagraphs } from '@/config/content'
import styles from './ContentPage.module.css'

export function AboutPage() {
  return (
    <>
      <PageHero title="Hakkımızda" subtitle={company.legalName} />
      <section className={styles.section}>
        <div className={`container ${styles.prose}`}>
          <p className={styles.brandName}>{company.name}</p>
          <h2 className={styles.legalTitle}>{company.legalName}</h2>
          {aboutParagraphs.map((p) => (
            <p key={p.slice(0, 40)}>{p}</p>
          ))}
          <dl className={styles.meta}>
            <div>
              <dt>Firma Ünvanı</dt>
              <dd>{company.legalName}</dd>
            </div>
            <div>
              <dt>Vergi Dairesi</dt>
              <dd>{company.taxOffice}</dd>
            </div>
            <div>
              <dt>Vergi No</dt>
              <dd>{company.taxId}</dd>
            </div>
            <div>
              <dt>NACE</dt>
              <dd>
                {company.activityCode} — {company.activityLabel}
              </dd>
            </div>
            <div>
              <dt>Çalışma Saatleri</dt>
              <dd>{company.workingHours}</dd>
            </div>
          </dl>
        </div>
      </section>
    </>
  )
}
